export const MY_POOQ_MENU_LIST = [
  { index: 0, title: '이용내역', path: '/mypooq/use_list_vod_history' },
  { index: 1, title: '취향분석', path: '/mypooq/taste_analysis' },
  { index: 2, title: '좋아요', path: '/mypooq/like_channel' },
  { index: 3, title: '구독한 프로그램', path: '/mypooq/like_program' },
  { index: 4, title: '나중에 볼 영화', path: '/mypooq/like_movie' },
  { index: 5, title: '시청예약알림', path: '/mypooq/reserve_watch' },
  { index: 6, title: '구매콘텐츠', path: '/mypooq/voucher_list_singular' },
  { index: 7, title: '이용권내역', path: '/mypooq/subscription_ticket' },
  { index: 8, title: '코인/쿠폰', path: '/mypooq/coin' },
  { index: 9, title: '1:1문의', path: '/mypooq/user_qna' }
]

export const AGREEMENT_MENU_LIST = [
  { index: 0, title: '서비스 이용약관', path: '/agreement/service' },
  { index: 1, title: '유료상품 이용약관', path: '/agreement/paid' },
  { index: 2, title: '개인정보 처리방침', path: '/agreement/privacy' },
  { index: 3, title: '청소년 보호정책', path: '/agreement/youth' },
  { index: 4, title: '웨이브온 사업자 이용약관', path: '/agreement/pooqzone' }
]

export const EVENT_MENU_LIST = [
  { index: 0, title: '진행중인 이벤트', path: '/event/list' },
  { index: 1, title: '당첨자 발표', path: '/event/board' }
]

export const MY_POOQ_VOUCHER_MENU_LIST = [
  { index: 0, title: 'wavve 이용권', value: 'index', path: '/voucher/index' },
  { index: 1, title: '쿠폰·코인', value: 'regist', path: '/voucher/regist' },
  { index: 2, title: '웨이브온 이용권', value: 'wavveon', path: '/voucher/wavveon' }
]
